module.exports = __webpack_public_path__ + "img/tooltip_caldera-2.199d1b07.jpg";